import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewRef } from '@angular/core';
import { MonthlyExpensesService } from '../../services/monthly-expenses.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-expenses-list',
    templateUrl: './expenses-list.component.html',
    styleUrls: ['./expenses-list.component.scss'],
    standalone: false
})
export class ExpensesListComponent implements OnInit {

  private displayedColumns: string[];
  private paginator: MatPaginator;
  private sort: MatSort;
  private currentRow: any;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(
    public monthlyExpensesService: MonthlyExpensesService,
    private sharedService: SharedService,
    public dialog: MatDialog,
    private changeDetector: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.displayedColumns = ['action', 'medico', 'empresa', 'fijoKm', 'km', 'precioKm',
      'totalKm', 'horas', 'precioHora', 'totalHora', 'dias', 'precioDia', 'totalDias', 'fijoMes'];
  }

  getDisplayedColumns(): string[] {
    return this.displayedColumns;
  }

  setDataSourceAttributes(): void {
    this.monthlyExpensesService.expensesList.paginator = this.paginator;
    this.monthlyExpensesService.expensesList.sort = this.sort;
  }

  calculateField(row: any, type: string, isValidated = false): void {
    if (row.traspasado === 'N' && (row.isEditing !== undefined && row.isEditing)) {
      switch (type) {
        case 'Km':
          if (String(row.km).includes(',')) {
            row.km = this.replaceSpanishFormat(String(row.km));
          }

          if (String(row.precioKm).includes(',')) {
            row.precioKm = this.replaceSpanishFormat(String(row.precioKm));
          }
          
          if (Number(row.km) > 0) {

            if (Number.isInteger(row.km)) {
              row.totalKm = Number(row.km) * Number(row.precioKm);
            } else {
              this.sharedService.ShowSnackBar('Ingrese un valor entero para Kms', 'okay', 2000);
              row.km = undefined;
            }

          } else if (isValidated && row.km !== undefined && row.km !== null) {
            this.sharedService.ShowSnackBar('Por favor, introduzca un valor positivo para Kms', 'okay', 2000);
            row.km = undefined;
          }
          break;

        case 'Hora':
          if (String(row.horas).includes(',')) {
            row.horas = this.replaceSpanishFormat(String(row.horas));
          }

          if (String(row.precioHora).includes(',')) {
            row.precioHora = this.replaceSpanishFormat(String(row.precioHora));
          }
          
          if (Number(row.horas) > 0) {
            row.totalHora = Number(row.horas) * Number(row.precioHora);
          } else if (isValidated && row.horas !== undefined && row.horas !== null) {
            this.sharedService.ShowSnackBar('Por favor ingrese un valor positivo por horas', 'okay', 2000);
            row.horas = undefined;
          }
          break;

        case 'Dia':
          if (String(row.dias).includes(',')) {
            row.dias = this.replaceSpanishFormat(String(row.dias));
          }

          if (String(row.precioDia).includes(',')) {
            row.precioDia = this.replaceSpanishFormat(String(row.precioDia));
          }
          
          
          if (Number(row.dias) > 0) {
            row.totalDias = Number(row.dias) * Number(row.precioDia);
          } else if (isValidated && row.dias !== undefined && row.dias !== null) {
            this.sharedService.ShowSnackBar('Por favor ingrese un valor positivo por días', 'okay', 2000);
            row.dias = undefined;
          }
          break;

        default:
          break;
      }

      const existingElement = this.monthlyExpensesService.expensesList.data.filter(e => e.id === row.id)[0];
      const index = this.monthlyExpensesService.expensesList.data.indexOf(existingElement);
      if (index > -1) {
        row.isEdited = true;
        this.monthlyExpensesService.expensesList.data.splice(index, 1, row);
        this.monthlyExpensesService.expensesList.data = this.monthlyExpensesService.expensesList.data;
        
        if (this.changeDetector && !(this.changeDetector as ViewRef).destroyed) {
          this.changeDetector.detectChanges();
        }
      }

    }
  }

  toggleRowEdit(selectedRow: any, isEditing: boolean): void {
    const existingElement = this.monthlyExpensesService.expensesList.data.filter(e => e.id === selectedRow.id)[0];
    const index = this.monthlyExpensesService.expensesList.data.indexOf(existingElement);
    if (index > -1) {
      if (isEditing) {
        if (this.currentRow !== undefined) {
          this.clearRowChanges();
        }
        this.currentRow = Object.assign({}, existingElement);
        this.monthlyExpensesService.expensesList.data.forEach(item => {
          item.isEditing = false;
        });
      }
      selectedRow.isEditing = isEditing;
      this.monthlyExpensesService.expensesList.data.splice(index, 1, selectedRow);
      this.monthlyExpensesService.expensesList.data = this.monthlyExpensesService.expensesList.data;
    }
  }

  updateRow(updatedRow: any): void {
    updatedRow = this.convertRowValues(updatedRow);
    this.monthlyExpensesService.updateExpenseRow(updatedRow).subscribe(res => {
      if (res.code === 0) {
        this.sharedService.ShowSnackBar('Fila actualizada con éxito', 'okay', 2000);
      } else {
        this.sharedService.ShowSnackBar('Fila actualizada falló', 'okay', 2000);
      }
      this.monthlyExpensesService.updateExpensesList(this.monthlyExpensesService.selectedDatePeriod);
    }, error => {
      this.sharedService.ShowSnackBar('Fila actualizada falló', 'okay', 2000);
      this.monthlyExpensesService.updateExpensesList(this.monthlyExpensesService.selectedDatePeriod);
      console.error(error);
    });

    this.toggleRowEdit(updatedRow, false);
  }

  clearRowChanges(): void {
    this.toggleRowEdit(this.currentRow, false);
  }

  deshacerTraspasoRecord(expenseId: number): void {
    const message = `Al deshacer el traspaso se eliminarán los conceptos de gastos mensuales de la empresa y
      médico seleccionados. ¿Continuar?`;
    const dialogData = new ConfirmDialogModel('Confirmar acción', message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.monthlyExpensesService.deshacerTraspasoRecord(expenseId).subscribe(res => {
          if (res.code === 0) {
            this.monthlyExpensesService.updateExpensesList(this.monthlyExpensesService.selectedDatePeriod);
            this.sharedService.ShowSnackBar('Transferir deshecho con éxito', 'okay', 2000);
          } else {
            this.sharedService.ShowSnackBar('Transferencia de deshacer fallida', 'okay', 2000);
          }
        }, error => {
          this.sharedService.ShowSnackBar('Transferencia de deshacer fallida', 'okay', 2000);
          console.error(error);
        });
      }
    });
  }

  repercutir(expenseItem: any): void {
    this.monthlyExpensesService.repercutirExpenseRecord(expenseItem).subscribe(res => {
      if (res.code === 0) {
        this.monthlyExpensesService.updateExpensesList(this.monthlyExpensesService.selectedDatePeriod);
        this.sharedService.ShowSnackBar('Gastos aprobados con éxito', 'okay', 2000);
      } else {
        this.sharedService.ShowSnackBar('Gastos aprobados fallados', 'okay', 2000);
      }
    }, error => {
      this.sharedService.ShowSnackBar('Gastos aprobados fallados', 'okay', 2000);
      console.error(error);
    });
  }

  replaceSpanishFormat(value: string): number {
    let replacedText = value.replace(/[^0-9,]*/g, '');
    replacedText = replacedText.replace(',', '.');
    return Number(replacedText);
  }

  convertRowValues(row: any): any {

    row.km = String(row.km).includes(',') ? this.replaceSpanishFormat(String(row.km)) : Number(row.km);
    row.precioKm = String(row.precioKm).includes(',') ? this.replaceSpanishFormat(String(row.precioKm)) : Number(row.precioKm);
    row.horas = String(row.horas).includes(',') ? this.replaceSpanishFormat(String(row.horas)) : Number(row.horas);
    row.precioHora = String(row.precioHora).includes(',') ? this.replaceSpanishFormat(String(row.precioHora)) : Number(row.precioHora);
    row.dias = String(row.dias).includes(',') ? this.replaceSpanishFormat(String(row.dias)) : Number(row.dias);
    row.precioDia = String(row.precioDia).includes(',') ? this.replaceSpanishFormat(String(row.precioDia)) : Number(row.precioDia);
    row.fijoKm = String(row.fijoKm).includes(',') ? this.replaceSpanishFormat(String(row.fijoKm)) : Number(row.fijoKm);
    row.fijoMes = String(row.fijoMes).includes(',') ? this.replaceSpanishFormat(String(row.fijoMes)) : Number(row.fijoMes);

    return row;
  }

}
